import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { blue, red } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { action, computed, makeObservable, observable, reaction, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import IconeNaoJulgado from '../../img/gavelN.svg';
import Configuracao from '../../util/Configuracao';
import IconePin from '../IconePin';
import PopoverSecretaria from '../PopoverSecretaria';
import ReactComponent from '../ReactComponent';
import ModalVistaRegimental from './ModalVistaRegimental';
import { RESULTADO_JULGAMENTO } from '@/dominio/ResultadoJulgamento';

class ResultadosJulgamentoProcessoNaoJulgado extends ReactComponent {
    abertoVistaRegimental = false;
    tipoJulgamento;
    codJulgamento;
    openResultadosJulgamento;

    constructor(props) {
        super(props);

        makeObservable(this, {
            abertoVistaRegimental: observable,
            tipoJulgamento: observable,
            codJulgamento: observable,
            openResultadosJulgamento: observable,
            fixo: computed,
            toggleFixo: action,
            permitirFixar: computed,
            registro: computed,
            naoJulgados: computed,
            handleClickJulgar: action,
            callbackOkVista: action,
            apreciar: action,
            callbackCancel: action,
            handleClickIcone: action,
            handleCloseResultadosJulgamento: action
        });

        runInAction(() => (this.openResultadosJulgamento = this.salaSessaoStore.fixarPainelJulgamento));

        this.createReaction(
            reaction(
                () => this.salaSessaoStore.fixarPainelJulgamento,
                () => (this.openResultadosJulgamento = this.salaSessaoStore.fixarPainelJulgamento)
            )
        );
    }

    get fixo() {
        return this.salaSessaoStore.fixarPainelJulgamento;
    }

    toggleFixo = () => {
        this.salaSessaoStore.toggleFixarPainelJulgamento();
    };

    get permitirFixar() {
        return this.observableProps.permitirFixar;
    }

    get registro() {
        return this.observableProps.registro;
    }

    get naoJulgados() {
        let retorno = this.dominioStore.tiposResultadoJulgamento.filter(
            (tipo) => !tipo.julgado && tipo.codigo !== RESULTADO_JULGAMENTO.NAO_JULGADO.codigo
        );
        retorno = this.filtrarResultadosDesabilitadosParaPJe(retorno);
        return retorno;
    }

    filtrarResultadosDesabilitadosParaPJe(retorno) {
        if (this.registro && this.registro.processo.origem === Configuracao.ORIGEM_PJE) {
            let removerPje = [
                RESULTADO_JULGAMENTO.EXCLUIDO_SESSAO.codigo,
                RESULTADO_JULGAMENTO.CANCELADO.codigo,
                RESULTADO_JULGAMENTO.RESOLUCAO.codigo,
                RESULTADO_JULGAMENTO.NAO_ACOLHIDA_AFETACAO.codigo,
                RESULTADO_JULGAMENTO.ACOLHIDA_AFETACAO.codigo
            ];
            retorno = retorno.filter((tipo) => removerPje.findIndex((codigo) => codigo === tipo.codigo) === -1);
        }
        return retorno;
    }

    handleClickJulgar = (tipoJulgamento) => {
        if (tipoJulgamento.codigo === RESULTADO_JULGAMENTO.VISTA_REGIMENTAL.codigo) {
            this.abertoVistaRegimental = true;
        } else {
            this.apreciar(tipoJulgamento.codigo);
            this.onClosePopover();
        }
    };

    onClosePopover = () => {
        if (!this.fixo && !this.abertoVistaRegimental) {
            this.handleCloseResultadosJulgamento();
        }
    };

    callbackOkVista = (vistas) => {
        this.abertoVistaRegimental = false;
        this.openResultadosJulgamento = false;
        this.apreciar(RESULTADO_JULGAMENTO.VISTA_REGIMENTAL.codigo, vistas);
    };

    apreciar = async (idTipoJulgamento, vistas) => {
        await this.observableProps.callbackApreciar(idTipoJulgamento, vistas);
    };

    callbackCancel = () => {
        this.abertoVistaRegimental = false;
        this.onClosePopover();
    };

    handleClickIcone = () => {
        this.openResultadosJulgamento = true;
    };

    handleCloseResultadosJulgamento = () => {
        this.openResultadosJulgamento = false;
    };

    render() {
        // Sequencial no id necessário caso o mesmo processo seja aberto no painel de detalhes e na modal.
        const idIconeApreciarNaoJulgado = 'iconeApreciarNaoJulgado-' + this.nextKey;
        return (
            <>
                <IconButton
                    id={idIconeApreciarNaoJulgado}
                    onClick={this.handleClickIcone}
                    style={{ padding: '8px' }}
                    size="large"
                >
                    <Tooltip
                        placement="top"
                        title={<Typography>Apreciar processo como não julgado</Typography>}
                    >
                        <img
                            src={IconeNaoJulgado}
                            alt="Apreciar processo como não julgado"
                        />
                    </Tooltip>
                </IconButton>
                <PopoverSecretaria
                    open={this.openResultadosJulgamento}
                    onClose={this.onClosePopover}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    elevation={12}
                    anchorEl={() => document.getElementById(idIconeApreciarNaoJulgado)}
                >
                    <Box style={{ display: 'flex', flexDirection: 'column' }}>
                        <Box
                            sx={{
                                padding: 1,
                                backgroundColor: blue[800],
                                color: 'white',
                                textAlign: 'center'
                            }}
                        >
                            <Typography sx={{ fontWeight: 'bold' }}>Não Julgado</Typography>
                        </Box>
                        {this.naoJulgados && this.naoJulgados.length > 0 && (
                            <MenuList
                                dense
                                sx={{ pt: 0, pb: 0, mr: 0.5 }}
                            >
                                {this.naoJulgados.map((tipoResultadoJulgamento) => {
                                    return (
                                        <MenuItem
                                            divider
                                            onClick={this.handleClickJulgar.bind(this, tipoResultadoJulgamento)}
                                            key={tipoResultadoJulgamento.codigo}
                                        >
                                            <ListItemText
                                                primary={<Typography>{tipoResultadoJulgamento.descricao}</Typography>}
                                            />
                                        </MenuItem>
                                    );
                                })}
                            </MenuList>
                        )}
                    </Box>
                    {this.permitirFixar && (
                        <>
                            <Divider />
                            <Tooltip title={<Typography>{this.fixo ? 'Desafixar janela' : 'Fixar janela'}</Typography>}>
                                <Box
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Button
                                        onClick={this.toggleFixo}
                                        style={{
                                            cursor: 'pointer',
                                            borderRadius: '24px',
                                            width: '4.5em',
                                            margin: '0.5em 0.5em'
                                        }}
                                        variant={this.fixo ? 'outlined' : 'contained'}
                                    >
                                        <IconePin color={this.fixo ? red[900] : 'white'} />
                                    </Button>
                                </Box>
                            </Tooltip>
                        </>
                    )}
                    <ModalVistaRegimental
                        aberto={this.abertoVistaRegimental}
                        callbackOk={this.callbackOkVista}
                        callbackCancel={this.callbackCancel}
                        registro={this.registro}
                    />
                </PopoverSecretaria>
            </>
        );
    }
}

export default inject('stores')(observer(ResultadosJulgamentoProcessoNaoJulgado));
